import type { LucideIcon } from 'lucide-react'
import * as React from 'react'
import { forwardRef } from 'react'

export const SchoolBuildingIcon: LucideIcon = forwardRef(({ size = 24, color = 'white', ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M22.5004 14.0544L20.0104 13.0567V10.8071C20.0009 10.265 19.7193 9.76299 19.2605 9.47296L12.8028 5.17513V4.79966H15.9972C16.2103 4.79966 16.4149 4.71528 16.5646 4.56447C16.7155 4.41471 16.7998 4.2101 16.7998 3.99706V0.802598C16.7998 0.35963 16.4402 0 15.9972 0H12C11.557 0 11.1974 0.35963 11.1974 0.802598V5.17513L4.71038 9.49501C4.26637 9.79348 3.99847 10.2944 3.99742 10.8302V13.0798L1.49999 14.0543C0.582439 14.4213 -0.014492 15.3167 0.000267616 16.3049V23.2192C0.0129235 23.6537 0.368335 23.9996 0.802865 23.9996H23.1974C23.4104 23.9996 23.614 23.9153 23.7648 23.7644C23.9156 23.6136 24 23.4101 24 23.197V16.2816C24.0032 15.3029 23.4083 14.4202 22.5003 14.0542L22.5004 14.0544ZM15.2023 3.20317H12.8018L12.8029 1.59797H15.2033L15.2023 3.20317ZM1.59826 16.2818C1.59615 15.9528 1.79548 15.6554 2.10027 15.532L3.9976 14.7821V22.4022H1.59826V16.2818ZM5.6027 10.8293L12.0002 6.5621L18.3976 10.8293V22.4021H15.9972V19.2002C15.9993 18.7752 15.8316 18.3681 15.5321 18.0686C15.2315 17.768 14.8244 17.6003 14.4004 17.6024H9.59974C9.17576 17.6003 8.76866 17.768 8.46809 18.0686C8.16857 18.3681 8.00086 18.7752 8.00298 19.2002V22.4021H5.60252L5.6027 10.8293ZM14.4006 22.4021H9.59994V19.2002H14.3995L14.4006 22.4021ZM22.4034 22.4021H20.003V14.782L21.9003 15.5319C22.2051 15.6553 22.4044 15.9527 22.4023 16.2817L22.4034 22.4021Z'
        fill={color}
      />
      <path
        d='M12.0018 12.8026C12.3266 12.8026 12.6188 12.6074 12.7432 12.3069C12.8677 12.0074 12.7991 11.6625 12.5692 11.4326C12.3393 11.2027 11.9944 11.1341 11.6949 11.2586C11.3943 11.383 11.1992 11.6752 11.1992 12C11.1992 12.4429 11.5588 12.8026 12.0018 12.8026Z'
        fill={color}
      />
    </svg>
  )
})

SchoolBuildingIcon.displayName = 'SchoolBuildingIcon'
